import { PermissionCheck } from './permission/PermissionCheck';
import { SubscriptionCheck } from './subscription/SubscriptionCheck';

class PermissionSubscriptionResult {
    constructor(permissionCheck, subscriptionCheck) {
        /** @type {PermissionResult} */
        this.permissionCheck = permissionCheck;
        /** @type {SubscriptionResult} */
        this.subscriptionCheck = subscriptionCheck;
    }

    /**
     *
     * @param {*} requiredLevel
     * @param {String[]} inhibitorModifiers -
     * eg: ['M3'] if current route has modifier that is in inhibitorModifiers, will NOT ALLOW feature
     * @returns
     */
    hasPermissionTo(requiredLevel, inhibitorModifiers) {
        const permission = this.permissionCheck.hasPermissionTo(requiredLevel, inhibitorModifiers);
        const subscription = this.subscriptionCheck.hasSubscriptionTo();
        const allowed = permission ? subscription : false;

        return {
            permission,
            subscription,
            allowed,
        };
    }
}

const PermissionSubscriptionCheck = {
    withUrl(url) {
        const permissionCheck = PermissionCheck.withUrl(url);
        const subscriptionCheck = SubscriptionCheck.withUrl(url);

        return new PermissionSubscriptionResult(permissionCheck, subscriptionCheck);
    },
    withCurrentRoute() {
        const permissionCheck = PermissionCheck.withCurrentRoute();
        const subscriptionCheck = SubscriptionCheck.withCurrentRoute();

        return new PermissionSubscriptionResult(permissionCheck, subscriptionCheck);
    },
    withRecurring(transactionType, isRecurring) {
        const permissionCheck = PermissionCheck.withRecurring(transactionType, isRecurring);
        const subscriptionCheck = SubscriptionCheck.withRecurring(transactionType, isRecurring);

        return new PermissionSubscriptionResult(permissionCheck, subscriptionCheck);
    },
};

export {
    PermissionSubscriptionCheck,
};
